import locales from '../../constants/locales'
import { paths } from '../../constants/paths'

export function getBasePath(locale = locales.defaultLocale) {
  return locale === locales.defaultLocale ? paths.getBaseURL() : `${paths.getBaseURL()}/${locale}`
}
